export const obtenerAniosDesde = (anio: number): number[] => {
  const anoActual = new Date().getFullYear(); // Año actual
  const anios: number[] = [];

  for (let i = anio; i <= anoActual + 1; i++) {
    anios.push(i);
  }

  return anios;
};

export const obtenerAniosDesdeOrdered = (anio: number): number[] => {
  const anoActual = new Date().getFullYear(); // Año actual
  const anios: number[] = [];

  // Luego agregamos el año ingresado y los intermedios hasta el año actual anterior
  for (let i = anoActual; i >= anio; i--) {
    anios.push(i);
  }

  return anios;
};
